export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const endPoints: {
  [key in "contact"]: string;
} = {
  contact: "contact/",
};
